import React, { FC, useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import useDataFromDom from './hooks/useDataFromDom';
import Loader from './components/Loader';
import ButtonPrimary from './components/ButtonPrimary';
import ButtonSecondary from './components/ButtonSecondary';
import ItemsDropDown from './components/ItemsDropDown';
import ProductResult from './components/ProductResult';
import { createStorefrontApiClient } from '@shopify/storefront-api-client';
import useContentful from "./hooks/useContentful";
import contentfulComponentLoop from "./lib/contentfulComponentLoop";
import getContentfulLocale from "./lib/getContentfulLocale";

const Container = styled.div`
  min-height: 50vh;
  padding-top: 40px;
  padding-bottom: 60px;

  @media (min-width: 990px) {
    padding-top: 40px;    
  }

  @media (min-width: 1158px) {
    padding-top: 40px; 
  }
  margin-left: 20px;
  margin-right: 20px;
`;

const SubContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
  flex-direction: column;
  @media (min-width: 990px) {
    flex-direction: row;
  }
`;

const SubContainerHeader = styled.div`
  margin-top: 10px;
`;

const SubContainerTwo = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 10px;
  flex-direction: column;
  @media (min-width: 990px) {
    flex-direction: row;
  }
`;

const SubContainerThree = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 10px;
`;

const SubContainerFour = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  border: 1px solid #000;
  padding: 15px;
  background: #f0f0f0;
`;

const HTag = styled.div`
    font-size: 24px;
    margin-top: 10px;
    margin-bottom: 20px;
    font-weight: 600;
    color: #000;
`;

const HTagOne = styled.div`
    font-size: 28px;
    margin-top: 20px;
    margin-bottom: 0;
`;

const HTagTwo = styled.div`
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 600;
    color: #000;
`;
const HTagThree = styled.div`
    margin-top: 40px;
    margin-bottom: 10px;
`;


const Index: FC = () => {
  const { title, content, collections, collectionids, products, shopLocale, shopMarket }: any = useDataFromDom(['data-data'], 'control');
  const [activeCollection, setActiveCollection] = useState('');
  const [activeProductArr, setActiveProductArr] = useState<any>([]);
  const [allCollections, setAllCollections] = useState<string[]>([]);
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [allProductsAll, setAllProductsAll] = useState<any[]>([]);
  const [activeProductName, setActiveProductName] = useState('');
  const [activeProductId, setActiveProductId] = useState('');
  const [error, setError] = useState<string>('');
  const [productResult, setProductResult] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [osVersion, setOsVersion] = useState<string>('');
  const [osVersionArr, setOsVersionArr] = useState<any[]>([]);
  const [hasOSVersion, setHasOSVersion] = useState<boolean>(false);

  const find_os = async () => {
    let OSVer = "";
    let OSVerArr = [
      "macOS 15 Sequoia",
      "macOS 14 Sonoma",
      "macOS 13 Ventura",
      "macOS 12 Monterey",
      "macOS 11.2 Big Sur",
      "macOS 10.15 Catalina",
      "macOS 10.14.7 Mojave",
      "macOS 10.14.6 Mojave",
      "macOS 10.13.6 High Sierra",
      "macOS 10.12.6 Sierra",
      "macOS 10.11.6 El Capitan",
      "Mac OS X 10.10.5 Yosemite",
      "Mac OS X 10.9.5 Mavericks",
      "Mac OS X 10.8.5 Mountain Lion",
      "Mac OS X 10.7.5 Lion",
      "Mac OS X 10.6.8 Snow Leopard",
      "Mac OS X 10.5.8 Leopard",
      "Mac OS X 10.4.11 Tiger",
      "Mac OS X 10.3.7 Panther",
      "Windows 11",
      "Windows 10 64-bit",
      "Windows 10 32-bit",
      "Windows 8.1 64-bit",
      "Windows 8.1 32-bit",
      "Windows 7 Service Pack 1 + Platform Updated 64",
      "Windows 7 Service Pack 1 + Platform Updated 32",
      "Windows Vista SP2 64-bit",
      "Windows Vista SP2 32-bit",
      "Windows XP 64-bit",
      "Windows XP 32-bit",
      "Android 6.0 - 6.0.1 Marshmallow",
      "Android 7.0 - 7.1.2 Nougat",
      "Android 8.0 - 8.1 Oreo",
      "Android 9.0 - 9.0 Pie",
      "Android 10.0 - 10.0 Q",
      "Android 11.0-11.0 Red Velvet Cake",
      "Android 12.0-12.1 Snow Cone",
      "Android 13.0-13.0 Tiramisu"
    ];
    if (navigator.userAgent.indexOf("Mac OS X 10_15_7") != -1) OSVer = "macOS 11.2 Big Sur";
    else if (navigator.userAgent.indexOf("Mac OS X 10_15") != -1) OSVer = "macOS 10.15 Catalina";
    else if (navigator.userAgent.indexOf("Mac OS X 10.4") != -1) OSVer = "Mac OS X 10.4.11 Tiger";
    else if (navigator.userAgent.indexOf("Mac OS X 10.5") != -1) OSVer = "Mac OS X 10.5.8 Leopard";
    else if (navigator.userAgent.indexOf("Mac OS X 10.6") != -1) OSVer = "Mac OS X 10.6.8 Snow Leopard";
    else OSVer = OSVerArr[0];
    setOsVersionArr(OSVerArr);
    setOsVersion(OSVer);
  }

  const locale = getContentfulLocale(shopLocale, shopMarket);
  const contentfulDiv = document.getElementById('contentful');
  let contentfulData;
  if (contentfulDiv) {
    const entryId = contentfulDiv?.dataset.entryId;
    if (entryId) {
      ({ contentfulData } = useContentful({ include: 10, 'sys.id': entryId, locale }));
    }
  }

  function getUTMParameter(param: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(param) ? urlParams.get(param) : null;
  }

  const handleActiveCollection = (collection: any, productsArr: any) => {
    setActiveProductName('');
    setActiveProductId('');
    setProductResult({});
    setActiveProductArr([]);
    find_os();
    //console.log("collection", collection)

    if (collection && collection !== '') {
      setError('');
      setActiveCollection(collection);
      let activeCollectionArr: any = [];
      if (productsArr && productsArr.length) {
        setAllProducts(productsArr);
        activeCollectionArr = productsArr.filter((product: any) => product.includes(collection));
      }
      else {
        setAllProducts(allProductsAll);
        activeCollectionArr = allProducts.filter((product: any) => product.includes(collection));
      }
      //console.log("allProducts", allProducts);
      //console.log("activeCollectionArr", activeCollectionArr)
      let allActiveProducts: any = [];
      for (let product of activeCollectionArr) {
        let productArr = product.split('|');
        if (allActiveProducts.indexOf(productArr[1]) < 0) {
          allActiveProducts.push(productArr[1]);
        }
      }
      //console.log("allActiveProducts", allActiveProducts)

      if (allCollections.indexOf(collection as string) > 0) {
        allActiveProducts.splice(0, 1);
      }
      
      setActiveProductArr(allActiveProducts);
    }
    else {
      setActiveCollection('');
    }
  };

  const handleActiveProduct = async (product: any, productsArr: any) => {
    // console.log("product", product)
    setIsLoading(true);
    setActiveProductName('');
    setActiveProductId('');
    setProductResult({});
    setHasOSVersion(false);

    if (product && product !== '') {
      setError('');
      // console.log("allProductsAll", allProductsAll)
      let activeProductArr = allProductsAll.find((productx: any) => productx.includes(product + '|'));
      // console.log("activeProductArr", activeProductArr)
      if (activeProductArr && !productsArr) {
        let activeProduct = activeProductArr.split('|');
        setActiveProductName(activeProduct[1]);
        setActiveProductId(activeProduct[2]);

        const configDomId = 'storefront-api-config';
        const configEl = document.getElementById(configDomId);
        const storeDomain = configEl?.dataset?.domain;
        const apiVersion = '2024-04';
        const publicAccessToken = configEl?.dataset?.token;

        if (!storeDomain || !publicAccessToken) {
          return;
        }

        const client = createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken });

        const productQuery = `
          query ProductQuery($handle: String) {
            product(handle: $handle) {
              id
              title
              handle
              featuredImage {
                url
                originalSrc
              }
              productSoftwareDocuments: metafield(namespace: "custom", key: "product_documents") {
                value
              }
              productSoftwareDownloads: metafield(namespace: "custom", key: "product_software_downloads") {
                value
              }
            }
          }
        `;
  
        const { data, errors } = await client.request(productQuery, {
          variables: {
            handle: activeProduct[2],
          },
        });

        if(data.product && data.product.productSoftwareDownloads) {
          setHasOSVersion(true);
        }

      }
      else if (productsArr) {
        let activeProductArr = productsArr.find((productx: any) => productx.includes(product + '|'));
       // console.log("activeProductArr", activeProductArr)
        if (activeProductArr) {
          let activeProduct = activeProductArr.split('|');
          setActiveProductName(activeProduct[1]);
          setActiveProductId(activeProduct[2]);

          const configDomId = 'storefront-api-config';
          const configEl = document.getElementById(configDomId);
          const storeDomain = configEl?.dataset?.domain;
          const apiVersion = '2024-04';
          const publicAccessToken = configEl?.dataset?.token;

          if (!storeDomain || !publicAccessToken) {
            return;
          }

          const client = createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken });

          const productQuery = `
            query ProductQuery($handle: String) {
              product(handle: $handle) {
                id
                title
                handle
                featuredImage {
                  url
                  originalSrc
                }
                productSoftwareDocuments: metafield(namespace: "custom", key: "product_documents") {
                  value
                }
                productSoftwareDownloads: metafield(namespace: "custom", key: "product_software_downloads") {
                  value
                }
              }
            }
          `;
    
          const { data, errors } = await client.request(productQuery, {
            variables: {
              handle: activeProduct[2],
            },
          });

          if(data.product && data.product.productSoftwareDownloads) {
            setHasOSVersion(true);
          }

        }
      }
      else {
        setActiveProductName('');
        setActiveProductId('');
        setProductResult({});
      }
    };
    setIsLoading(false);
  };

  const handleActiveOS = (os: any) => {
    setProductResult({});
    if (os && os !== '') {
      setError('');
      setOsVersion(os);
    }
    else {
      setOsVersion('');
    }
  };

  const open = async () => {
    setError('');
    setProductResult({});
    if (!activeCollection) {
      setError('Please select a category');
      setProductResult({});
    }
    else if (!activeProductName || !activeProductId) {
      setError('Please select a product');
      setProductResult({});
    }
    else if (!osVersion || osVersion == '') {
      setError('Please select an OS');
      setProductResult({});
    }
    else {
      //('activeCollection', activeCollection);
      //console.log('activeProductName', activeProductName);
      //console.log('activeProductId', activeProductId);

      setIsLoading(true);

      const configDomId = 'storefront-api-config';
      const configEl = document.getElementById(configDomId);
      const storeDomain = configEl?.dataset?.domain;
      const apiVersion = '2024-04';
      const publicAccessToken = configEl?.dataset?.token;

      if (!storeDomain || !publicAccessToken) {
        return;
      }

      // Todo: useStorefrontApi hook?
      const client = createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken });

      const productQuery = `
        query ProductQuery($handle: String) {
          product(handle: $handle) {
            id
            title
            handle
            featuredImage {
              url
              originalSrc
            }
            productSoftwareDocuments: metafield(namespace: "custom", key: "product_documents") {
              value
            }
            productSoftwareDownloads: metafield(namespace: "custom", key: "product_software_downloads") {
              value
            }
          }
        }
      `;

      const { data, errors } = await client.request(productQuery, {
        variables: {
          handle: activeProductId,
        },
      });

     // console.log('data', data);
     // console.log('errors', errors);

      if (errors && errors.message) {
        setError(errors.message);
        setProductResult({});
      }
      else if (!data.product || !data.product.title) {
        setError('Product not found');
        setProductResult({});
      }
      else {
        if (data.product && data.product.productSoftwareDocuments) {
          data.product.productSoftwareDocuments.value = JSON.parse(data.product.productSoftwareDocuments.value);
        }
        if (data.product && data.product.productSoftwareDownloads) {
          data.product.productSoftwareDownloads.value = JSON.parse(data.product.productSoftwareDownloads.value);
        }
        if (data.product.productSoftwareDownloads && data.product.productSoftwareDownloads.value && data.product.productSoftwareDownloads.value.downloads && data.product.productSoftwareDownloads.value.downloads.length > 0) {
          data.product.productSoftwareDownloads.value.downloads.sort((a: any, b: any) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
          let downloads = data.product.productSoftwareDownloads.value.downloads;
          let downloadsFiltered = downloads.filter((download: any) => (download.os.toLowerCase().includes(osVersion.toLowerCase()) || (!download.file_type || !download.file_type.toLowerCase().includes('software'))));
          data.product.productSoftwareDownloads.value.downloads = downloadsFiltered;
        }

        setProductResult(data.product);
      }
      setIsLoading(false);
    }
  };

  const close = async () => {
    setIsLoading(true);
    setActiveProductName('');
    setActiveProductId('');
    setProductResult({});
    setActiveProductArr([]);
    setActiveCollection('');
    setError('');
    find_os();
    setIsLoading(false);
  };

  const getAllProducts = async (collectionsArr: any, collectionsArrName: any) => {
    let productsArr: any = [];
    let count = 0;
    for (const collection of collectionsArr) {
     // console.log('collection', collection);

      const configDomId = 'storefront-api-config';
      const configEl = document.getElementById(configDomId);
      const storeDomain = configEl?.dataset?.domain;
      const apiVersion = '2024-04';
      const publicAccessToken = configEl?.dataset?.token;

      if (!storeDomain || !publicAccessToken) {
        return;
      }

      // Todo: useStorefrontApi hook?
      const client = createStorefrontApiClient({ storeDomain, apiVersion, publicAccessToken });

      const collectionQuery = `
        query CollectionQuery($handle: String) {
          collection(handle: $handle) {
            products (first: 250) {
              edges {
                node {
                  title
                  handle
                  id
                }
              }
            }
          }
        }
      `;

      const { data, errors } = await client.request(collectionQuery, {
        variables: {
          handle: collection,
        },
      });

     // console.log('data', data);
     // console.log('errors', errors);

      if(data && data.collection && data.collection.products && data.collection.products.edges) {
        data.collection.products.edges.forEach((product: any) => {
          productsArr.push(collectionsArrName[count] + '|' + product.node.title + '|' + product.node.handle + '|' + product.node.id);
        });
      }
      count++;
    };

    return productsArr;
  };

  
  const getAllData = async () => {
    let collectionsArr = collections?.split(',');
     setAllCollections(collectionsArr);
    // console.log('collectionsArr', collectionsArr);

     let collectionIdsArr = collectionids?.split(',');
     let productsArr = await getAllProducts(collectionIdsArr, collectionsArr);
     
     setAllProducts(productsArr);
     setAllProductsAll(productsArr);
 
    // console.log('productsArr', productsArr);
 
     const isProduct = getUTMParameter('product');
     if (isProduct) {
      // console.log('isProduct', isProduct);
       let productArr = productsArr.find((product: any) => product.includes(isProduct + '|'));
       if (productArr) {
         //console.log('productArr', productArr);
         let product = productArr.split('|');
         handleActiveCollection(product[0], productsArr);
         handleActiveProduct(product[1], productsArr);
       }
       else {
         find_os();
       }
     }
  };

  const runOnLoad = async () => {
    setIsLoading(true);
    await getAllData();
    setIsLoading(false);
  };

  if (collections && !allCollections.length) {
    runOnLoad();
  }

  return (
    <>
      <HTagThree>
        {contentfulData ? contentfulComponentLoop(contentfulData.items[0].fields.components, { locale }) : <HTagOne>{title}</HTagOne>}
      </HTagThree>
      <Container>
        {collections && allProducts && !isLoading ?
          <>
            { !productResult || !productResult.title ?
            <>
             <SubContainerHeader>
              <HTag>{content}</HTag>
            </SubContainerHeader>
              <SubContainer>
                <SubContainerThree>
                  <HTagTwo>Category</HTagTwo>
                  <ul className="react-ul">
                    {allCollections && allCollections.length > 0 && allCollections.map((collection: any, index: any) => (
                      <li className={activeCollection === collection ? 'react-li active-li' : 'react-li'} key={index} onClick={() => handleActiveCollection(collection, null)} >{collection}</li>
                    ))}
                  </ul>
                </SubContainerThree>
                <SubContainerThree>
                  <HTagTwo>Product</HTagTwo>
                  <ul className="react-ul">
                    {activeProductArr && activeProductArr.length > 0 && activeProductArr.map((product: any, index: any) => (
                      <li className={activeProductName === product ? 'react-li active-li' : 'react-li'} key={index} onClick={() => handleActiveProduct(product, null)} >{product}</li>
                    ))}
                  </ul>
                </SubContainerThree>
                <SubContainerThree>
                  <HTagTwo>Operating System</HTagTwo>
                  <ul className="react-ul">
                    {hasOSVersion && activeProductId && activeProductId !== '' && osVersionArr && osVersionArr.length > 0 && osVersionArr.map((os: any, index: any) => (
                      <li className={activeProductId && activeProductId !== '' && osVersion && osVersion === os ? 'react-li active-li' : 'react-li'} key={index} onClick={() => handleActiveOS(os)} >{os}</li>
                    ))}
                    {!hasOSVersion && activeProductId && activeProductId !== '' && osVersionArr && osVersionArr.length > 0 ? 
                    <li className="react-li react-no-pointer">N/A</li> : null }
                  </ul>
                  <ul>
                  </ul>
                </SubContainerThree>
              </SubContainer>
              <SubContainerTwo>
                <ButtonPrimary text="Show Results" functionx={open} />
              </SubContainerTwo>
            </>
            : null }
            {error && error !== '' ? <HTagTwo>{error}</HTagTwo> : null}
            { productResult && productResult.title ? 
            <>
            <ProductResult productResult={productResult} osVersion={hasOSVersion ? osVersion : ''} />           
            <SubContainerTwo>
              <ButtonSecondary text="Start Over" functionx={close} />
            </SubContainerTwo></> : null}
            </>
          : isLoading ? <Loader /> : <HTagTwo>No Data</HTagTwo>
        }
      </Container>
    </>
  );
}
ReactDOM.render(<Index />, document.getElementById('react'));